module.exports = __webpack_public_path__ + "img/granja.c0668bfe.png";